import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GiftCardService } from '../../services/giftcard.service';
import { OrderService } from '../../../order/services/order.service';
import { Router } from '@angular/router';
import { Product } from '../../../order/models/product';

@Component({
  selector: 'app-giftcard-page',
  templateUrl: './giftcard.page.html',
  styleUrls: ['./giftcard.page.css']
})
export class GiftcardPageComponent implements OnInit {


  customGiftCardProduct: Observable<Product[]>;

  constructor(
  ) { }

  ngOnInit() {
  }
}
